/**
 * Fetches the product recommendations section HTML (see Shopify Ajax API:
 * GET /{locale}/recommendations/products?product_id=&section_id=&limit=&intent=)
 * removes skeleton placeholders, then appends the fetched list items to the existing ul.
 */
if (typeof ProductRecommendations === "undefined") {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			this._loadToken = 0;
		}

		connectedCallback() {
			if (this._autoLoadStarted) return;
			this._autoLoadStarted = true;
			this.load();
		}

		/** Clear fetched cards and re-fetch from `data-url` (e.g. after Barba PDP swap). */
		load() {
			const url = this.dataset.url;
			if (!url) return;

			const token = ++this._loadToken;
			this._clearFetchedItems();

			fetch(url)
				.then((response) => {
					if (!response.ok) throw new Error(`HTTP ${response.status}`);
					return response.text();
				})
				.then((text) => {
					if (token !== this._loadToken) return;

					const wrapper = document.createElement("div");
					wrapper.innerHTML = text;
					const next = wrapper.querySelector("ul");

					if (next && next.innerHTML.trim().length) {
						const ul = this.querySelector("ul");
						if (!ul) return;

						ul.querySelectorAll(".skeleton-list-item").forEach((el) => el.remove());

						const fragment = document.createDocumentFragment();
						next.querySelectorAll(":scope > li").forEach((li) => {
							fragment.appendChild(li);
						});
						ul.appendChild(fragment);
					}
				})
				.catch((e) => {
					if (token !== this._loadToken) return;
					console.error("Error fetching product recommendations:", e);
				});
		}

		_clearFetchedItems() {
			const ul = this.querySelector("ul");
			if (!ul) return;
			ul.querySelectorAll(":scope > li:not(.skeleton-list-item)").forEach((el) => el.remove());
		}
	}

	if (!window.customElements.get("product-recommendations")) {
		window.customElements.define("product-recommendations", ProductRecommendations);
	}
}
